import type { Unit } from "../units/Unit";

// Attack bars are unused in turn-based combat — units auto-attack once per turn if eligible.
export class AttackBar {
  constructor(private _unit: Unit) {}
  update(_dt: number): void {}
  draw(_ctx: CanvasRenderingContext2D, _cx: number, _cy: number, _alpha?: number): void {}
}
